import React, { useState } from "react";
import { format } from "timeago.js";
import * as timeago from "timeago.js";
import pt_BR from "timeago.js/lib/lang/pt_BR";
import axios from "axios";

export default function NoticiacardAngola({ noticias }) {
  return (
    <>
      <div
        className="card"
        data-bs-toggle="modal"
        data-bs-target="#fill-dark-modal"
      >
        <img
          src={noticias.capa}
          className="card-img-top"
          alt="Card image cap"
        />
        <div className="card-body">
          <h5 className="card-title">{noticias.title}</h5>
          <p className="card-text">{noticias.desc}</p>
          <p className="card-text">
            <small className="text-muted">
              {/* {" "}
              {format(noticias.data, "pt_BR")} */}
              {noticias.data}
            </small>{" "}
            <br />
            <small>Fonte: {noticias.fonte}</small>
          </p>
        </div>
      </div>
    </>
  );
}
